import type { GameStatus, PlayerColor } from '@chess/core';

export function shouldShowGameBoard(
  color: PlayerColor,
  gameState: { status: GameStatus } | null
): boolean {
  if (color === 'black') return true;
  return gameState !== null && gameState.status !== 'waiting';
}
